import Modal from 'services/modal';
import BaseService from 'services/base';

const InquiryService = Object.assign(
  {
    save(config: any = {}, cb: Function = () => {}, dispatch: Function) {},
    publishBidding(postbody, cb: Function = () => {}, dispatch: Function) {
      let ok = () => {
        let config = {
          ...postbody,
          successMsg: '操作成功'
        };
        this.save(config, cb, dispatch);
      };
      Modal.showConfirm('确认发布竞价项目？', ok, dispatch);
    },
    cancelBidding(postbody, cb: Function = () => {}, dispatch: Function) {
      let ok = () => {
        let config = {
          ...postbody,
          successMsg: '操作成功'
        };
        this.save(config, cb, dispatch);
      };
      Modal.showConfirm('确认取消竞价项目？', ok, dispatch);
    },
    publishResult(postbody, cb: Function = () => {}, dispatch: Function) {
      let ok = () => {
        let config = {
          ...postbody,
          successMsg: '操作成功'
        };
        this.save(config, cb, dispatch);
      };
      Modal.showConfirm('确认发布竞价结果项目？', ok, dispatch);
    },
    publishScore(postbody, cb: Function = () => {}, dispatch: Function) {
      let ok = () => {
        let config = {
          ...postbody,
          successMsg: '操作成功'
        };
        this.save(config, cb, dispatch);
      };
      Modal.showConfirm('确认发布评标？', ok, dispatch);
    },
    confirmCustomerBidding(
      postbody,
      cb: Function = () => {},
      dispatch: Function
    ) {
      let ok = () => {
        let config = {
          ...postbody,
          successMsg: '操作成功'
        };
        this.save(config, cb, dispatch);
      };
      let text =
        postbody.confirmBiddingFlag === 1
          ? '确认参与竞价项目？'
          : '确认放弃竞价项目？';
      Modal.showConfirm(text, ok, dispatch);
    },
    quotePriceBidding(postbody, cb: Function = () => {}, dispatch: Function) {
      let ok = () => {
        let config = {
          ...postbody,
          successMsg: '操作成功'
        };
        this.save(config, cb, dispatch);
      };
      Modal.showConfirm('确认提交报价？', ok, dispatch);
    },
    giveUpBidding(postbody, cb: Function = () => {}, dispatch: Function) {
      let ok = () => {
        let config = {
          ...postbody,
          successMsg: '操作成功'
        };
        this.save(config, cb, dispatch);
      };
      Modal.showConfirm('确认放弃竞价？', ok, dispatch);
    },
    /************ 询价 begin ********************/
    publishInquiry(postbody, cb: Function = () => {}, dispatch: Function) {
      let ok = () => {
        let config = {
          ...postbody,
          successMsg: '操作成功'
        };
        this.save(config, cb, dispatch);
      };
      Modal.showConfirm('确认发布询价/招标？', ok, dispatch);
    },
    cancelInquiry(postbody, cb: Function = () => {}, dispatch: Function) {
      let ok = () => {
        let config = {
          ...postbody,
          successMsg: '操作成功'
        };
        this.save(config, cb, dispatch);
      };
      Modal.showConfirm(
        '您确定取消本次询价 / 招标吗？\n取消后，将不可恢复。',
        ok,
        dispatch
      );
    },
    finishInquiry(postbody, cb: Function = () => {}, dispatch: Function) {
      let ok = () => {
        let config = {
          ...postbody,
          successMsg: '操作成功'
        };
        this.save(config, cb, dispatch);
      };
      Modal.showConfirm(
        '本次询价截止时间未到，\n您确定提前结束本次询价吗？',
        ok,
        dispatch
      );
    },
    // 结束申请
    finishApplyInquiry(postbody, cb: Function = () => {}, dispatch: Function) {
      // let ok = () => {
      let config = {
        ...postbody,
        successMsg: '操作成功'
      };
      this.save(config, cb, dispatch);
      // };
      // Modal.showConfirm(
      //   '本次询价截止时间未到，\n您确定提前结束本次询价吗？',
      //   ok,
      //   dispatch
      // );
    },

    completeInquiry(postbody, cb: Function = () => {}, dispatch: Function) {
      let ok = () => {
        let config = {
          ...postbody,
          successMsg: '操作成功'
        };
        this.save(config, cb, dispatch);
      };
      Modal.showConfirm(
        '终止后，询价/招标结果不会发送给供应商。\n您确定要进行该操作吗？',
        ok,
        dispatch
      );
    },
    publishInquiryResult(
      postbody,
      cb: Function = () => {},
      dispatch: Function
    ) {
      let ok = () => {
        let config = {
          ...postbody,
          successMsg: '操作成功'
        };
        this.save(config, cb, dispatch);
      };
      Modal.showConfirm('确认发布询价/招标结果？', ok, dispatch);
    },
    publishQuoteInquiry(
      postbody,
      cb: Function = () => {},
      dispatch: Function,
      data?
    ) {
      let confirmMsg = '确认发送报价？';
      if (data) {
        confirmMsg = data.msgInfo + '，是否继续';
      }
      let ok = () => {
        let config = {
          ...postbody,
          ignoreZeroTaxRate: data ? 1 : 0,
          successMsg: '操作成功'
        };
        this.save(config, cb, dispatch);
      };
      Modal.showConfirm(confirmMsg, ok, dispatch);
    },
    // 开始比价
    startPriceCompare(postbody, cb: Function = () => {}, dispatch: Function) {
      let ok = () => {
        let config = {
          ...postbody,
          successMsg: '操作成功'
        };
        this.save(config, cb, dispatch);
      };
      Modal.showConfirm('确认开始比价？', ok, dispatch);
    },

    /************ 询价 end ********************/

    /************ 比价 begin ********************/
    publishPriceCompare(postbody, cb: Function = () => {}, dispatch: Function) {
      let ok = () => {
        let config = {
          ...postbody,
          successMsg: '操作成功'
        };
        this.save(config, cb, dispatch);
      };
      Modal.showConfirm('确认发布比价结果？', ok, dispatch);
    },
    terminatePriceCompare(
      postbody,
      cb: Function = () => {},
      dispatch: Function
    ) {
      let ok = (reason?) => {
        if (!reason) {
          Modal.showError('终止原因不能为空', dispatch);
          return;
        }
        let config = {
          ...postbody,
          terminateReason: reason,
          successMsg: '操作成功'
        };
        this.save(config, cb, dispatch);
      };
      Modal.showReject('确认终止？', ok, '终止', 'showReject', '', dispatch);
    },
    reactivatePriceCompare(
      postbody,
      cb: Function = () => {},
      dispatch: Function
    ) {
      let ok = () => {
        let config = {
          ...postbody,
          successMsg: '操作成功'
        };
        this.save(config, cb, dispatch);
      };
      Modal.showConfirm('您确认要重新比价吗？', ok, dispatch);
    },
    finishPriceCompare(postbody, cb: Function = () => {}, dispatch: Function) {
      let ok = () => {
        let config = {
          ...postbody,
          successMsg: '操作成功'
        };
        this.save(config, cb, dispatch);
      };
      Modal.showConfirm('您确认要结束比价吗？', ok, dispatch);
    },
    /************ 比价 end ********************/

    /************ 商机 begin ********************/
    publishOppOrder(postbody, cb: Function = () => {}, dispatch: Function) {
      let ok = () => {
        let config = {
          ...postbody,
          successMsg: '操作成功'
        };
        this.save(config, cb, dispatch);
      };
      Modal.showConfirm('确认发布商机线索？', ok, dispatch);
    },

    returnOppOrder(postbody, cb: Function = () => {}, dispatch: Function) {
      let ok = (reason?) => {
        if (!reason) {
          Modal.showError('退回原因不能为空', dispatch);
          return;
        }
        let config = {
          ...postbody,
          returnDesc: reason,
          successMsg: '操作成功'
        };
        this.save(config, cb, dispatch);
      };
      Modal.showReject('确认退回？', ok, '退回', 'showReject', '', dispatch);
    },

    ConfirmOppOrder(postbody, cb: Function = () => {}, dispatch: Function) {
      let ok = () => {
        let config = {
          ...postbody,
          successMsg: '操作成功'
        };
        this.save(config, cb, dispatch);
      };
      Modal.showConfirm('确认发布商机线索？', ok, dispatch);
    },
    /************ 商机 end ********************/
    publishProjectIfb(postbody, cb: Function = () => {}, dispatch: Function) {
      let ok = () => {
        let config = {
          ...postbody,
          successMsg: '操作成功'
        };
        this.save(config, cb, dispatch);
      };
      Modal.showConfirm('确认发布招标？', ok, dispatch);
    }
  },
  BaseService
);

export default InquiryService;
